'use strict';

(function () {

  angular
    .module('specsguardApp')
    .directive('showonhoverparent', showonhoverparent);

  showonhoverparent.$inject = ['$timeout'];

  function showonhoverparent ($timeout) {

    return {
      link: function (scope, element, attrs) {
        // hide by default
        if (element.hide) {
          element.hide();
        }

        // but show when active (after initial $digest cycle...)
        $timeout(function () {
          if (element.parent().hasClass('active')) {
            if (element.show) {
              element.show();
            }
          }
        }, 0);

        // show on mouse enter
        element.parent().bind('mouseenter', function () {
          if (element.show) {
            element.show();
          }
        });

        // hide when leaving mouse
        element.parent().bind('mouseleave', function () {
          if (!element.parent().hasClass('active')) {
            if (element.hide) {
              element.hide();
            }
          }
        });
      }
    };
  }

})();
